import styled from "styled-components";

const SubtleMetadata = styled.div`
  color: #888;
  font-size: 12px;
`;

export default SubtleMetadata;
